(() => {
  const CACHE_PREFIX = 'td-product-yotpo:';

  const formatScore = (value) => (Math.round(value * 10) / 10).toFixed(1);

  const formatCount = (total) => `(${total.toLocaleString('en-US')} reviews)`;

  const readCache = (cacheKey) => {
    try {
      const raw = localStorage.getItem(`${CACHE_PREFIX}${cacheKey}`);
      if (!raw) return null;
      const parsed = JSON.parse(raw);
      return parsed?.fetchedAt ? parsed : null;
    } catch {
      return null;
    }
  };

  const writeCache = (cacheKey, payload) => {
    try {
      localStorage.setItem(`${CACHE_PREFIX}${cacheKey}`, JSON.stringify(payload));
    } catch {
      /* ignore */
    }
  };

  const fetchYotpo = async (appKey, productId) => {
    const url = `https://api-cdn.yotpo.com/v1/widget/${encodeURIComponent(appKey)}/products/${encodeURIComponent(productId)}/reviews.json?per_page=1`;
    const response = await fetch(url);
    if (!response.ok) throw new Error(`Yotpo request failed (${response.status})`);

    const data = await response.json();
    const bottomline = data?.response?.bottomline;
    if (!bottomline) throw new Error('Yotpo response missing bottomline');

    return {
      fetchedAt: Date.now(),
      averageScore: bottomline.average_score ?? bottomline.averageScore ?? 0,
      totalReviews: bottomline.total_review ?? bottomline.total_reviews ?? 0,
    };
  };

  const applyData = (root, data) => {
    const scoreEl = root.querySelector('[data-td-product-score]');
    const countEl = root.querySelector('[data-td-product-review-count]');

    if (scoreEl) scoreEl.textContent = formatScore(data.averageScore);
    if (countEl) countEl.textContent = formatCount(data.totalReviews);

    root.setAttribute(
      'aria-label',
      `${formatScore(data.averageScore)} out of 5 stars based on ${data.totalReviews} reviews`
    );
    root.dataset.tdProductYotpoLoaded = 'true';
  };

  const initRoot = async (root) => {
    const appKey = root.dataset.yotpoAppKey;
    const productId = root.dataset.yotpoProductId;
    const cacheHours = Number(root.dataset.yotpoCacheHours || 24);
    const cacheKey = root.dataset.yotpoCacheKey || `${appKey}:${productId}`;
    const cacheTtlMs = Math.max(1, cacheHours) * 60 * 60 * 1000;

    if (!appKey || !productId) return;

    const cached = readCache(cacheKey);
    if (cached && Date.now() - cached.fetchedAt < cacheTtlMs) {
      applyData(root, cached);
      return;
    }

    try {
      const data = await fetchYotpo(appKey, productId);
      writeCache(cacheKey, data);
      applyData(root, data);
    } catch {
      if (cached) applyData(root, cached);
    }
  };

  const init = () => {
    document.querySelectorAll('[data-td-product-yotpo]').forEach((root) => {
      initRoot(root);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
